export default {
  mobileMaxWidth: 768
};
